import { AnalyticsListener } from "@atlaskit/analytics-next";
import FeaturesHighlightWpl from "@atlassiansox/bxpkit-features-highlight-wpl";
import { LAYOUT_TYPE, MEDIA_TYPE } from "@atlassiansox/bxpkit-features-highlight-wpl/lib/commonjs/src/utils/constants";
import React from "react";
import { IntlProvider } from "react-intl";
import { trackEvent } from '../../../common/analytics';

const getLayoutTypeEnum = (layoutType: string) => {
  return layoutType == "cards_right" ? LAYOUT_TYPE.CARDS_RIGHT : LAYOUT_TYPE.CARDS_LEFT;
}

const getMediaTypeEnum = (mediaType: string) => {
  return mediaType == "video" ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.IMAGE;
}

function sendAnalytics({ payload, context }) {
  const analyticsDataList = [...context, payload];
  const analyticsEvent = analyticsDataList.reduce((mergedAnalyticsEvent, currentAnalyicsEvent) => {
    return {...mergedAnalyticsEvent, ...currentAnalyicsEvent};
  }, {})
  trackEvent(analyticsEvent.eventName, analyticsEvent);
}

type FeaturesHighlightContainerType = {
  readonly layoutType: string,
  readonly selectedBgColor: string,
  readonly isColorBar: boolean,
  readonly isCategoryLabel: boolean,
  readonly barColor: string,
  readonly mediaType: string,
  readonly image1Src: string,
  readonly image2Src: string,
  readonly image3Src: string,
  readonly video1Src: string,
  readonly video2Src: string,
  readonly video3Src: string,
  readonly labels : { [key: string]: string }
}

export default function FeaturesHighlightContainer (
  {
  layoutType,
  selectedBgColor, 
  isColorBar,
  isCategoryLabel,
  barColor,
  mediaType,
  image1Src,
  image2Src,
  image3Src,
  video1Src,
  video2Src,
  video3Src, 
  labels}: FeaturesHighlightContainerType
  ) {
    
  let mediaTypeEnum = getMediaTypeEnum(mediaType);
  let mediaSourceLinks = [];
  if (mediaTypeEnum == MEDIA_TYPE.VIDEO) {
    mediaSourceLinks = [video1Src, video2Src, video3Src];
  } else {
    mediaSourceLinks = [image1Src, image2Src, image3Src];
  }
  return (
    <AnalyticsListener onEvent={sendAnalytics}>
      <IntlProvider
        locale={document.documentElement.lang}
        messages={labels}
      >
        <FeaturesHighlightWpl
          layoutType={getLayoutTypeEnum(layoutType)}
          selectedBgColor={selectedBgColor}
          isColorBar={isColorBar}
          barColor={barColor}
          isCategoryLabel={isCategoryLabel}
          mediaType={mediaTypeEnum}
          mediaSourceLinks={mediaSourceLinks} />
      </IntlProvider>
    </AnalyticsListener>
  );
};